// Though InfoMedia is a server component and this could be in the same file,
// it's separate to avoid circular dependency between PDP and course page.
export const infoMediaFragment = `
  fragment infoMediaFragment on InfoMediumRecord {
    button {
      ...buttonFragment
    }
    content {
      blocks
      links
      value
    }
    headingProps {
      textStyle
    }
    image {
      responsiveImage(
        imgixParams: {
          auto: format
          cornerRadius: "8"
          fit: crop
          h: 303
          mask: corners
          q: 45
          w: 550
        }
      ) {
        ...responsiveImageFragment
      }
    }
    mapEmbed
    mediaSide
    moduleFormat {
      ...moduleFormatFragment
    }
    title
    video {
      ...cmsVideoFragment
    }
  }
`;
